import React from 'react';
import { PawPrintIcon, CatIcon, LeafIcon, DropletIcon } from 'lucide-react';
interface ProductCardProps {
  name: string;
  price: number;
  category: string;
  badge?: string;
  badgeType?: 'blue' | 'green' | 'warm';
  memberPrice?: number;
  imageColor?: 'blue' | 'green' | 'warm';
  iconType?: 'dog' | 'cat' | 'garden' | 'pool';
  onNavigate?: (page: 'product') => void;
}
export function ProductCard({
  name,
  price,
  category,
  badge,
  badgeType = 'blue',
  memberPrice,
  imageColor = 'blue',
  iconType = 'dog',
  onNavigate
}: ProductCardProps) {
  const bgColorClass = {
    blue: 'bg-brand-blue-50',
    green: 'bg-brand-green-50',
    warm: 'bg-warm-100'
  }[imageColor];
  const badgeClass = {
    blue: 'badge-blue',
    green: 'badge-green',
    warm: 'badge-warm'
  }[badgeType];
  const getIcon = () => {
    const iconProps = {
      className: 'w-24 h-24 md:w-32 md:h-32',
      strokeWidth: 1.5
    };
    const colorClass = {
      blue: 'text-brand-blue-300',
      green: 'text-brand-green-300',
      warm: 'text-warm-300'
    }[imageColor];
    const icons = {
      dog: <PawPrintIcon {...iconProps} className={`${iconProps.className} ${colorClass}`} data-id="element-619" />,
      cat: <CatIcon {...iconProps} className={`${iconProps.className} ${colorClass}`} data-id="element-620" />,
      garden: <LeafIcon {...iconProps} className={`${iconProps.className} ${colorClass}`} data-id="element-621" />,
      pool: <DropletIcon {...iconProps} className={`${iconProps.className} ${colorClass}`} data-id="element-622" />
    };
    return icons[iconType];
  };
  return <div className="card-interactive flex flex-col h-full cursor-pointer group active:scale-[0.98]" onClick={() => onNavigate && onNavigate('product')} data-id="element-623">
      <div className={`relative w-full aspect-square ${bgColorClass} rounded-t-2xl flex items-center justify-center overflow-hidden`} data-id="element-624">
        {badge && <div className="absolute top-3 right-3 z-10" data-id="element-625">
            <span className={badgeClass} data-id="element-626">{badge}</span>
          </div>}
        <div className="transition-transform duration-300 group-hover:scale-110" data-id="element-627">
          {getIcon()}
        </div>
      </div>

      <div className="p-5 flex flex-col flex-grow" data-id="element-628">
        <span className="text-xs text-gray-500 mb-1 font-medium uppercase tracking-wider" data-id="element-629">
          {category}
        </span>
        <h3 className="font-heading font-semibold text-gray-900 text-base line-clamp-2 mb-3 flex-grow leading-tight" data-id="element-630">
          {name}
        </h3>

        <div className="mt-auto mb-4" data-id="element-631">
          <div className="text-xl font-bold text-brand-blue" data-id="element-632">
            ${price.toFixed(2)}
          </div>
          {memberPrice && <div className="text-sm font-semibold text-brand-green mt-0.5" data-id="element-633">
              ${memberPrice.toFixed(2)} for members
            </div>}
        </div>

        <button className="btn-primary w-full py-3 text-sm flex items-center justify-center gap-2 active:scale-95" onClick={e => {
        e.stopPropagation();
        // In a real app, this would add to cart
      }} data-id="element-634">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-635">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" data-id="element-636" />
          </svg>
          Add to Cart
        </button>
      </div>
    </div>;
}